import { useEffect, useRef } from 'react';
import { Button, Time, PinInput } from '@burna/monster-design-system';
import styles from './styles.module.scss';

function Verify({ secondsLeft, pin, disabled, onChange, onEdit, onResend }) {
  const pinRef = useRef();
  useEffect(() => pinRef.current.focus(), []);

  return (
    <div className={styles.wrapper}>
      <div className={styles.verify}>
        <Time secondsLeft={secondsLeft} hasIcon />
        <div className={styles.actions}>
          <Button
            type="button"
            className={styles.action}
            hierarchy="secondary-outlined"
            icon="edit"
            text="Edit number"
            disabled={disabled}
            onClick={onEdit}
          />
          <Button
            type="button"
            className={styles.action}
            hierarchy="secondary-outlined"
            icon="refresh-cw"
            text="Resend code"
            disabled={disabled || secondsLeft > 0}
            onClick={onResend}
          />
        </div>
        <PinInput
          ref={pinRef}
          value={pin}
          onChange={onChange}
          disabled={disabled}
          digitsCount={6}
        />
      </div>
    </div>
  );
}

export default Verify;
